import { render } from "./RandomEvent.vue?vue&type=template&id=4582a4fc"
import script from "./RandomEvent.vue?vue&type=script&lang=js"
export * from "./RandomEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__